import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';



// O provider para os dados do cliente
import { AuthProvider } from '../../providers/auth/auth';
import { VERSION_APP } from '../../constants/version';

@Component({
  selector: 'page-sobre',
  templateUrl: 'sobre.html',
})
export class SobrePage {

	version:any = 0;

	constructor(public navCtrl: NavController, public navParams: NavParams, private _auth: AuthProvider)
	{
		this.getVersion();
	}

	// Executar sempre que a página for aberta, mesmo se for voltando
    ionViewDidEnter()
    {
        // Confirma login sempre que entrar na pagina
        this._auth.confirmaLogin();
    }

	getVersion()
	{
		this.version = VERSION_APP;
		// console.log(this.version);
	}

}



// WEBPACK FOOTER //
// ./src/pages/sobre/sobre.ts